import COSToverview from './overview.json';
import costSummary from './widget/costSummary.json';
import clusterListSelector from './widget/filter/clusterListSelector.json';
import namespaceListSelector from './widget/filter/namespaceListSelector.json';
import timeselector from './widget/filter/timeselector.json';
import workloadhighestcost from './widget/workloadHighestCost.json';
import teamheighestcost from './widget/teamHighestCost.json';
import totalcostbyday from './widget/totalcostbyday.json';
import totalcostbyweek from './widget/totalcostbyweek.json';

export default [
  timeselector,
  totalcostbyday,
  totalcostbyweek,
  teamheighestcost,
  workloadhighestcost,
  namespaceListSelector,
  clusterListSelector,
  costSummary,
  COSToverview,
];
